import { request } from '@umijs/max';
import { RequestType } from '@/interface';
import { AccountBalanceType } from '@/pages/Mine/interface';

/**
 * @description 查询小区树结构
 */
export const queryCommunityTreeList = () =>
  request('/api/community/base/community/wx/tree', {
    method: 'GET',
    params: {
      category: 'room',
    },
  });

/**
 * @desc 查询账户余额
 * @param params
 */
export const queryAccountBalance = async (params: { customerId: string }) =>
  request<Promise<RequestType<AccountBalanceType>>>(
    '/api/community/charge/account/balance',
    {
      method: 'GET',
      params,
    },
  );

/**
 * @desc 根据房屋id查询客户详情
 * @param params
 */
export const queryCustomerDetail = async (params: { roomId?: string }) =>
  request('/api/community/base/customer/charged/detail', {
    method: 'GET',
    params,
  });

/**
 * @desc 查询账户详情列表
 * @param params
 */
export const queryAccountDetailList = async (params: { customerId: string }) =>
  request('/api/community/charge/account/list', {
    method: 'GET',
    params,
  });

/**
 * @desc 查询账户流水列表
 * @param params
 */
export const queryAccountInformationDetailList = async (params: {
  accountNo: string;
}) =>
  request('/api/community/charge/account/serial/page', {
    method: 'GET',
    params: {
      ...params,
      pageNum: 1,
      pageSize: 999,
    },
  });
